<!-- 底部导航栏 -->
<template>
    <div class="bottom_wrapper">
        <div class="bottom_lists">
            <div class="bottom_list">
                <div class="split"
                    v-for="(item, idx) in appList"
                    :key="idx">
                    <a :href="item.link">{{item.name}}</a>{{idx == (appList.length-1)? '': '/'}}
                </div>
            </div>
            <div class="bottom_list">
                <div class="split"
                    v-for="(item, idx) in qaList"
                    :key="idx">
                    <a :href="item.link">{{item.name}}</a>{{idx == (qaList.length-1)? '': '/'}}
                </div>
            </div>
            <div class="bottom_list">©2019 北京网易有道计算机系统有限公司 京ICP证080268号</div>

        </div>
        <div class="bottom_msg">
          违法和不良信息举报电话：020-85105163，转分机号：54776；举报邮箱：youdao_jubao@rd.netease.com；<a href="https://www.12377.cn" target="_blank">网上有害信息举报专区</a>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeIndex: '1',
                appList: [
                    {
                        name: '网易有道词典',
                        link: 'http://dict.youdao.com/?cookie=new'
                    },
                    {
                        name: '有道云笔记',
                        link: 'https://note.youdao.com/web/'
                    },
                    {
                        name: '有道精品课',
                        link: 'https://ke.youdao.com/'
                    },
                    {
                        name: '有道智云',
                        link: 'https://ai.youdao.com/'
                    }
                ],
                qaList: [
                    {
                        name: '关于智选',
                        link: 'http://c.youdao.com/dsp/zhixuan_ow.html#/about'
                    },
                    {
                        name: '加入我们',
                        link: 'http://hr.youdao.com/'
                    },
                    {
                        name: '隐私权政策',
                        link: 'https://c.youdao.com/dsp/law/privacy.html'
                    },
                    {
                        name: '经销商专区',
                        link: 'http://adagent.youdao.com/agent/'
                    }
                ]
            };
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            }
        }
    }
</script>
<style scoped>
    .bottom_wrapper {
        margin-top: 19px;
        margin-bottom: 17px;
        text-align: center;
        min-width: 1280px;
        /* margin-bottom: 65px; */
        color: #C0C6D1;
    }
    .bottom_lists {
        font-size: 0;
        margin: auto;
        width: 1280px;
        /* text-align: justify; */
        position: relative;
        margin-bottom: 10px;
    }
    .bottom_list {
        display: inline-block;
        font-family: "PingFangSC-Regular";
        font-size: 12px;
        letter-spacing: 0;
        text-align: justify;
        line-height: 12px;
        color: #C0C6D1;
    }
    .bottom_lists .bottom_list:nth-child(1) {
        float: left;
    }
    .bottom_lists .bottom_list:nth-child(2) {
        position: absolute;
        left: 50%;
        margin-left: -137px;
    }
    .bottom_lists .bottom_list:nth-child(3) {
        float: right;
    }
    .bottom_list .split {
        display: inline-block;
    }
    .bottom_list a, .bottom_msg a{
        text-decoration: none;
        padding:0 5px;
        color: #C0C6D1;
    }

    .bottom_list a:hover {
        text-decoration: underline;
    }
    .bottom_lists:after {
        width: 100%;
        height: 0;
        margin: 0;
        display: inline-block;
        overflow: hidden;
        content: '';
    }
</style>




// WEBPACK FOOTER //
// src/components/BottomMsg.vue